import { render, staticRenderFns } from "./BlockTransporterModal.vue?vue&type=template&id=31ff75c5&scoped=true"
import script from "./BlockTransporterModal.vue?vue&type=script&lang=ts"
export * from "./BlockTransporterModal.vue?vue&type=script&lang=ts"
import style0 from "./BlockTransporterModal.vue?vue&type=style&index=0&id=31ff75c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff75c5",
  null
  
)

export default component.exports